<h2 mat-dialog-title>{{videoDetails.title}}</h2>
<mat-dialog-content>
  <div class="videoWrapper">
    <!-- <iframe [src]='safeUrl' frameborder="0" allowfullscreen></iframe> -->
    <video controls width="100%">
      <source [src]='safeUrl'
              type="video/mp4">

      Sorry, your browser doesn't support embedded videos.
  </video>

  </div>
</mat-dialog-content>

<hr>

<mat-dialog-actions class="app-dialog-actions justify-content-end">
  <button type="button" class="btn closeBtn btn-sm" (click)="close()">Close</button>
</mat-dialog-actions>
